/* SKINGRAPHICA redesign, Our Science. Stage bar sits under the site header and follows the reader */
(function () {
  var root = document.querySelector('[data-sci]');
  if (!root) return;
  var tabs = [].slice.call(root.querySelectorAll('[data-sci-tab]'));
  var cards = tabs.map(function (a) { return document.getElementById(a.getAttribute('data-sci-tab')); });
  var hdr = document.querySelector('.sg-hdr-sec') || document.querySelector('header');
  function setTop() {
    var y = 0;
    if (hdr) { var r = hdr.getBoundingClientRect(); y = Math.max(0, Math.round(r.bottom)); }
    root.style.setProperty('--sci-top', y + 'px');
  }
  function spy() {
    var line = (parseFloat(getComputedStyle(root).getPropertyValue('--sci-top')) || 0) + 140;
    var cur = -1;
    cards.forEach(function (c, i) { if (c && c.getBoundingClientRect().top <= line) cur = i; });
    tabs.forEach(function (a, i) {
      var on = i === cur;
      a.classList.toggle('on', on);
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  }
  tabs.forEach(function (a, i) {
    a.addEventListener('click', function (e) {
      var c = cards[i];
      if (!c) return;
      e.preventDefault();
      var top = c.getBoundingClientRect().top + window.scrollY - ((parseFloat(getComputedStyle(root).getPropertyValue('--sci-top')) || 0) + 60);
      window.scrollTo({ top: top, behavior: 'smooth' });
      if (history.replaceState) history.replaceState(null, '', '#' + c.id);
    });
  });
  [].slice.call(root.querySelectorAll('[data-sci-rm]')).forEach(function (b) {
    b.addEventListener('click', function () {
      var card = b.closest('.sci-card');
      if (card) card.classList.add('is-open');
      b.setAttribute('aria-expanded', 'true');
    });
  });
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { setTop(); spy(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', function () { setTop(); spy(); });
  setTop(); spy();
})();
